import Parseable from '@/models/Parseable';
import Project from '@/models/Project';
import ContactPerson from '@/models/ContactPerson';
import { CustomerType, isCustomerType } from '@/constants/customerTypes';

export interface CustomerRef {
    id?: string;
    name?: string;
    customerNumber?: string;
    customerType?: CustomerType;
}

export default class Customer extends Parseable {

    public id!: string;
    public name!: string;
    public street!: string;
    public houseNo!: string;
    public additionalStreet!: string;
    public zipCode!: number;
    public city!: string;
    public country!: string;

    public customerType?: CustomerType;

    // Assigned by the backend on creation ("K1000", ...), read-only afterwards.
    public customerNumber?: string;

    // Optional Octoflex ERP customer number
    public erpCustomerNumber?: string;

    // Not provided by the backend yet; the company list shows them once they exist.
    public email?: string;
    public phone?: string;

    public contactPersons: ContactPerson[] = [];

    public projects: Project[] = [];

    /**
     * Turns a plain object to a class object
     * @param object
     */
    public static parseFromObject(object: Partial<Customer>): Customer {
        const customer = new Customer();
        Object.assign(customer, object);
        customer.projects = Array.isArray(object.projects)
            ? Project.parseFromArray(object.projects)
            : [];
        customer.contactPersons = ContactPerson.parseFromArray(object.contactPersons);
        if (!isCustomerType(customer.customerType)) {
            customer.customerType = undefined;
        }
        return customer;
    }

    public static parseFromArray(array: Partial<Customer>[]): Customer[] {
        if (!Array.isArray(array)) {
            return [];
        }
        return array.map((obj) => Customer.parseFromObject(obj));
    }

    parseToObject(): any {
        const tmp: any = { ...this };
        return tmp;
    }
}
